import { render, staticRenderFns } from "./dbTableEdit.vue?vue&type=template&id=7771cb82&"
import script from "./dbTableEdit.vue?vue&type=script&lang=js&"
export * from "./dbTableEdit.vue?vue&type=script&lang=js&"
import style0 from "./dbTableEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports